module.exports = __webpack_public_path__ + "static/media/C1.a01aa5f0.PNG";